import { render, staticRenderFns } from "./CostService.vue?vue&type=template&id=35986717&"
import script from "./CostService.vue?vue&type=script&lang=js&"
export * from "./CostService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports